// src/data/projects.ts
export const projects = [
  {
    id: 1,
    title: "Yedi Mavi",
    location: "Zeytinburnu, Istanbul",
    tag: "Sea View • Ready",
    image: "https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=1400&q=80"
  },
  {
    id: 2,
    title: "Sinpaş Queen",
    location: "Bomonti, Istanbul",
    tag: "Premium • New Build",
    image: "https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=1400&q=80"
  },
  {
    id: 3,
    title: "Nişantaşı Koru",
    location: "Nişantaşı, Istanbul",
    tag: "Luxury • City Core",
    image: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=1400&q=80"
  },
  {
    id: 4,
    title: "Akkurt Residence",
    location: "Başiskele, Kocaeli",
    tag: "Off-Plan • High Yield",
    image: "https://images.unsplash.com/photo-1513584684374-8bab748fbf90?auto=format&fit=crop&w=1400&q=80"
  },
  {
    id: 5,
    title: "Pekdemir Heights",
    location: "Yuvacık, Kocaeli",
    tag: "New Launch • Family Living",
    image: "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=1400&q=80"
  }
];